// extracted by mini-css-extract-plugin
export var banner = "_rn-0";
export var settingRow = "_rn-2";
export var titleIcon = "_rn-1";